
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface ProfileTabsProps {
  language: Language;
  activeTab: 'overview' | 'services' | 'flows' | 'agents' | 'integrations' | 'keys' | 'subscriptions';
  onSetActiveTab: (tab: any) => void;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ language, activeTab, onSetActiveTab }) => {
  const t = TRANSLATIONS[language];
  const isRtl = language === 'ar';

  const tabs = [
    { id: 'overview', label: isRtl ? 'نظرة عامة' : 'Overview', icon: 'fa-chart-pie' },
    { id: 'subscriptions', label: isRtl ? 'الاشتراكات' : 'Subscriptions', icon: 'fa-file-invoice-dollar' },
    { id: 'keys', label: isRtl ? 'مفاتيح الوصول' : 'Access Keys', icon: 'fa-key' },
    { id: 'services', label: t.servicesMode, icon: 'fa-cubes' },
    { id: 'flows', label: t.flowsMode, icon: 'fa-diagram-project' },
    { id: 'agents', label: t.robotMode, icon: 'fa-robot' },
    { id: 'integrations', label: t.integrationsMode, icon: 'fa-network-wired' },
  ] as const;

  return (
    <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 no-scrollbar">
       {tabs.map(tab => (
          <button 
            key={tab.id} 
            onClick={() => onSetActiveTab(tab.id)} 
            className={`
              flex items-center gap-2 px-6 py-3.5 rounded-2xl text-xs font-black uppercase tracking-wider transition-all whitespace-nowrap border
              ${activeTab === tab.id 
                ? 'bg-slate-900 dark:bg-white text-white dark:text-slate-900 shadow-xl shadow-slate-900/10 border-transparent scale-105' 
                : 'bg-white dark:bg-[#15151a] text-slate-500 dark:text-slate-400 border-slate-200 dark:border-white/5 hover:bg-slate-50 dark:hover:bg-white/5'}
            `}
          >
             <i className={`fas ${tab.icon} ${activeTab === tab.id ? 'text-emerald-400 dark:text-emerald-600' : ''}`}></i>
             {tab.label}
          </button>
       ))}
    </div>
  );
};
export default ProfileTabs;
